var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"disabled":_vm.saving,"variant":"success"},on:{"click":_vm.click}},[(_vm.saving)?_c('i',{staticClass:"fa fa-cog fa-spin fa-fw"}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }